<template>
  <a-modal
    :title="title"
    width="600px"
    :height="700"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    style="top:30%;height: 55%;overflow-y: hidden">
      <a-form-model :model="form" :rules="HandelRules" ref="formRef" label-width="120px">
        <div v-if="form.status === '2'">
          <a-form-model-item label="承运人" prop="carrier">
            <a-input v-model="form.carrier"/>
          </a-form-model-item>
          <a-form-model-item label="承运人电话" prop="carrierMobile">
            <a-input v-model="form.carrierMobile"/>
          </a-form-model-item>
          <a-form-model-item label="车号">
            <a-input v-model="form.carNo"/>
          </a-form-model-item>
        </div>
        <div v-if="form.status === '3'">
          <a-form-model-item label="签收人" prop="signtor">
            <a-input v-model="form.signtor"/>
          </a-form-model-item>
          <a-form-model-item label="签收日期" prop="signTime">
            <j-date v-model="form.signTime" :show-time="true"/>
          </a-form-model-item>
          <a-form-model-item label="签收单">
            <j-upload v-model="form.signFileName" bizPath="bill"></j-upload>
          </a-form-model-item>
        </div>
      </a-form-model>
  </a-modal>

</template>
<script>
import JDate from '@/components/jeecg/JDate'
import {Logistics} from '@api/logistics'
import moment from 'moment/moment'
import JUpload from "@comp/jeecg/JUpload";
import {JeecgListMixin} from "@/mixins/JeecgListMixin";
export default {
  name: "LogisticsModal",
  mixins: [JeecgListMixin],
  components: {
    JDate,JUpload
  },
  data() {
    return {
      title:'',
      form:{
        id:null,
        number:null,
        createTime:null,
        operTime : moment().format('YYYY-MM-DD HH:mm:ss'),
        creator:null,
        totalPrice:null,
        remark:null,
        fileName:null,
        salesMan:null,
        status:null,
        linkNumber:null,
        linkHeadId:null,
        linkHeadNumber:null,
        address:null,
        carrier:null,
        carrierMobile:null,
        carNo:null,
        deliveryTime:null,
        arrivalTime:null,
        signtor:null,
        signTime:null,
        signFileName:null,
        tenantId:null,
        phoneNum:null,
        contacts:null,
        distributor:null,
        preparer:null,
        deleteFlag:null
      },
      formRef:null,
      confirmLoading:false,
      visible: false,
      // 表头
      columns: [],
      HandelRules : {
        signtor: [{required: true, message: '请选择签收人!'}],
        signTime: [{required: true, message: '请选择签收时间!'}],
        carrier: [{required: true, message: '请输入承运人!'}],
        carrierMobile: [{required: true, message: '请输入承运人电话!'}],
      }
    }
  },
  methods: {
    handleCancel(){
      this.visible = false
    },
    show(record){
      this.visible = true
      if (record.status === '2') {
        this.title = '发货'
      } else if (record.status === '3') {
        this.title = '签收'
      }
      Object.assign(this.form, record)
    },
    handleOk(){
      this.$refs.formRef.validate( (valid ) =>{
        if(valid){
          Logistics.save(this.form).then(() => {
            console.log(this.form)
            this.$message.success('操作成功')
            this.$emit('reload')
            this.handleCancel()
          })
        }
      })
    }
  }
}
</script>